(function () {
  if (window.__mdcLampOptions) return;
  window.__mdcLampOptions = true;

  var COLORS = {
    'bleu ciel': '#a8c8dc', 'sky blue': '#a8c8dc', 'bleu clair': '#9abbd5',
    'light blue': '#9abbd5', 'bleu fonce': '#274567', 'dark blue': '#274567',
    'bleu gris': '#718b9b', 'blue grey': '#718b9b', 'blue gray': '#718b9b',
    'rouge bordeaux': '#702c3e', bordeaux: '#702c3e', bordeau: '#702c3e',
    burgundy: '#702c3e', 'rouge fonce': '#782733', 'dark red': '#782733',
    'rouge corail': '#d96b57', 'coral red': '#d96b57', 'rouge violet': '#873b66',
    'rose saumon': '#dfa092', saumon: '#dfa092', salmon: '#dfa092',
    'or rose': '#c79280', 'rose gold': '#c79280',
    'vert fonce': '#244a38', 'dark green': '#244a38',
    'vert clair': '#a6bc88', 'light green': '#a6bc88',
    'vert pomme': '#83a952', 'apple green': '#83a952',
    'vert olive': '#7d844d', olive: '#7d844d',
    'vert menthe': '#9fc7af', 'mint green': '#9fc7af',
    'vert armee': '#626a46', 'army green': '#626a46',
    'jaune clair': '#e9d786', 'light yellow': '#e9d786',
    'gris fume': '#777773', 'smoke grey': '#777773', 'smoke gray': '#777773',
    'marron clair': '#aa896b', 'light brown': '#aa896b',
    'bois clair': '#c8a67b', 'light wood': '#c8a67b',
    'bois fonce': '#79563c', 'dark wood': '#79563c',
    'bois noyer': '#7b5136', 'walnut wood': '#7b5136',
    'bois naturel': '#a77b4f', 'natural wood': '#a77b4f',
    'laiton ancien': '#9b8050', 'antique brass': '#9b8050',
    'jade blanc': '#f0eee3', 'white jade': '#f0eee3',
    'blanc casse': '#f1ebdd', 'off white': '#f1ebdd',
    noir: '#171717', noire: '#171717', noires: '#171717', black: '#171717',
    blanc: '#f7f3ea', blanche: '#f7f3ea', blanches: '#f7f3ea', white: '#f7f3ea',
    ivoire: '#eee4cf', ivory: '#eee4cf', rose: '#d89a9f', pink: '#d89a9f',
    vert: '#2f6b57', verte: '#2f6b57', green: '#2f6b57',
    ambre: '#c77a2c', amber: '#c77a2c', rouge: '#9c2e35', red: '#9c2e35',
    bleu: '#3a6196', bleue: '#3a6196', blue: '#3a6196',
    marine: '#1f3454', navy: '#1f3454', beige: '#d6c3a0', creme: '#eee2c8',
    cream: '#eee2c8', brun: '#744f3b', marron: '#744f3b', brown: '#744f3b',
    or: '#c6a15b', gold: '#c6a15b', golden: '#c6a15b', dore: '#c6a15b',
    doree: '#c6a15b', argent: '#b7bec5', argente: '#b7bec5', silver: '#b7bec5',
    silvery: '#b7bec5', aluminium: '#b7bec5', aluminum: '#b7bec5',
    gris: '#9ca3a6', grise: '#9ca3a6', gray: '#9ca3a6', grey: '#9ca3a6',
    fume: '#777773', smoke: '#777773', orange: '#d66e32',
    jaune: '#d8b43f', yellow: '#d8b43f', violet: '#79568f', purple: '#79568f',
    cuivre: '#b87333', copper: '#b87333', bronze: '#8c6239', cafe: '#6f4e37',
    chrome: '#c8ced4', laiton: '#b79a59', brass: '#b79a59',
    noyer: '#7b5136', walnut: '#7b5136', bois: '#a77b4f', wood: '#a77b4f',
    jade: '#80a992', corail: '#d96b57', coral: '#d96b57'
  };

  var CHECKER = 'repeating-conic-gradient(#f6f5f2 0% 25%, #d1d1cc 0% 50%) 0 0 / 8px 8px';
  var NEUTRAL = 'repeating-linear-gradient(135deg, #e5e2db 0 5px, #f5f3ee 5px 10px)';
  var RAINBOW = 'conic-gradient(#d89a9f, #c6a15b, #2f6b57, #3a6196, #d89a9f)';

  function normalize(value) {
    return (value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
  }

  var colorRules;
  var colorCache = new Map();
  var styleLabels = new Set();
  var styleObservation = { attributes: true, attributeFilter: ['style'] };

  function swatchFor(value) {
    var normalized = normalize(value);
    if (colorCache.has(normalized)) return colorCache.get(normalized);
    var multicolorMatch = /(^|[^a-z0-9])(multicolou?rs?|multicolores?|polychrome|degrade|gradient|tricolore|arc-en-ciel|rainbow)(?=$|[^a-z0-9])/.exec(normalized);
    if (multicolorMatch) {
      var multicolor = {
        background: RAINBOW,
        requiresLabel: hasMixedColorDetails(normalized) || normalized !== multicolorMatch[2]
      };
      colorCache.set(normalized, multicolor);
      return multicolor;
    }
    if (!colorRules) {
      var definitions = Object.keys(COLORS).map(function (key) {
        return { key: key, color: COLORS[key], patterned: false };
      });
      ['transparent', 'clear', 'givre', 'frosted'].forEach(function (key) {
        definitions.push({ key: key, color: 'rgba(255,255,255,.42)', patterned: true });
      });
      colorRules = definitions.sort(function (a, b) { return b.key.length - a.key.length; }).map(function (definition) {
        var escaped = definition.key.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
        return {
          pattern: new RegExp('(^|[^a-z0-9])(' + escaped + ')(?=$|[^a-z0-9])', 'g'),
          color: definition.color,
          patterned: definition.patterned
        };
      });
    }
    var matches = [];
    colorRules.forEach(function (rule) {
      rule.pattern.lastIndex = 0;
      var match;
      while ((match = rule.pattern.exec(normalized))) {
        var start = match.index + match[1].length;
        var end = start + match[2].length;
        var overlaps = matches.some(function (existing) { return start < existing.end && end > existing.start; });
        if (!overlaps) matches.push({ start: start, end: end, color: rule.color, patterned: rule.patterned });
      }
    });
    matches.sort(function (a, b) { return a.start - b.start; });
    var remainder = normalized.split('');
    matches.forEach(function (match) {
      for (var i = match.start; i < match.end; i += 1) remainder[i] = ' ';
    });
    var unrecognized = remainder.join('')
      .replace(/\b(?:verre|glass|ceramiques?|ceramics?|tissu|fabric|marbre|marble|travertin|travertine|mat|matte|brillant|brillante|glossy|striee?|echo|bulgari|ancien|cable|body|finition|finish|effet|effect|et|and)\b/g, '')
      .replace(/[\s&/+|(),.-]/g, '');
    var patterned = matches.some(function (match) { return match.patterned; });
    var background = NEUTRAL;
    if (matches.length === 1) {
      background = patterned ? CHECKER : matches[0].color;
    } else if (matches.length > 1) {
      var stops = matches.map(function (match, index) {
        return match.color + ' ' + (index * 100 / matches.length).toFixed(3) + '% ' +
          ((index + 1) * 100 / matches.length).toFixed(3) + '%';
      });
      background = 'linear-gradient(135deg, ' + stops.join(', ') + ')';
      if (patterned) background += ', ' + CHECKER;
    }
    var result = {
      background: background,
      requiresLabel: matches.length === 0 || unrecognized.length > 0 || hasMixedColorDetails(normalized)
    };
    colorCache.set(normalized, result);
    return result;
  }

  function hasMixedColorDetails(value) {
    return /\d\s*(?:cm|mm|m\b|in\b|inch|″|")|\b(?:lot|pack|pieces?|no adapt|adaptateur|adapter|modele|model|round|rond|ovale|square|semicircle|semicirlc|fusee|etoile|lune)\b/.test(value);
  }

  function colorFor(value) {
    return swatchFor(value).background;
  }

  function displayValue(input) {
    return input.getAttribute('data-mdc-display-value') || input.value;
  }

  function updateCurrentColor(fieldset) {
    var legend = fieldset.querySelector('legend');
    var selected = fieldset.querySelector('input:checked');
    if (!legend || !selected) return;
    if (fieldset.hasAttribute('data-mdc-color-only') && !fieldset.hasAttribute('data-mdc-model-picker')) {
      var previous = legend.querySelector('.mdc-color-current');
      if (previous) previous.remove();
      return;
    }
    var current = legend.querySelector('.mdc-color-current');
    if (!current) {
      current = document.createElement('span');
      current.className = 'mdc-color-current';
      legend.appendChild(current);
    }
    var selectedText = ': ' + displayValue(selected);
    if (current.textContent !== selectedText) current.textContent = selectedText;
  }

  function matchingOptions(root, selector) {
    var scope = root || document;
    var matches = Array.prototype.slice.call(scope.querySelectorAll(selector));
    if (scope.matches && scope.matches(selector)) matches.unshift(scope);
    return matches;
  }

  function watchOptionStyle(label) {
    if (styleLabels.has(label)) return;
    styleLabels.add(label);
    optionsObserver.observe(label, styleObservation);
  }

  function forgetDetachedStyles() {
    if (!Array.from(styleLabels).some(function (label) { return !label.isConnected; })) return;
    optionsObserver.disconnect();
    optionsObserver.observe(document.documentElement, { childList: true, subtree: true });
    styleLabels.forEach(function (label) {
      if (!label.isConnected) styleLabels.delete(label);
      else optionsObserver.observe(label, styleObservation);
    });
  }

  function enhanceColors(root) {
    matchingOptions(root, "fieldset[data-mdc-color-picker='true']").forEach(function (fieldset) {
      fieldset.querySelectorAll('.variant-option__button-label').forEach(function (label) {
        var input = label.querySelector('input');
        if (!input) return;
        watchOptionStyle(label);
        var color = colorFor(input.value);
        var display = displayValue(input);
        if (!fieldset.hasAttribute('data-mdc-color-only') && swatchFor(input.value).requiresLabel && fieldset.getAttribute('data-mdc-color-labels') !== 'true') {
          fieldset.setAttribute('data-mdc-color-labels', 'true');
        }
        if (label.style.getPropertyValue('--mdc-swatch') !== color) label.style.setProperty('--mdc-swatch', color);
        if (fieldset.hasAttribute('data-mdc-color-only')) label.removeAttribute('title');
        else if (label.getAttribute('title') !== display) label.setAttribute('title', display);
        if (label.getAttribute('aria-label') !== display) label.setAttribute('aria-label', display);
      });
      updateCurrentColor(fieldset);
      if (fieldset.dataset.mdcColorChangeReady !== 'true') {
        fieldset.dataset.mdcColorChangeReady = 'true';
        fieldset.addEventListener('change', function () {
          window.requestAnimationFrame(function () { updateCurrentColor(fieldset); });
        });
      }
    });
  }

  function disableProductsWithoutWarm(root) {
    (root || document).querySelectorAll('[data-mdc-no-warm-fr]').forEach(function (notice) {
      document.querySelectorAll("product-form button[type='submit'], button[name='add'], .shopify-payment-button button, .sticky-add-to-cart__button").forEach(function (button) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
      });
      document.querySelectorAll('.sticky-add-to-cart__variant').forEach(function (variant) {
        if (variant.textContent.trim() !== 'Non disponible en France') variant.textContent = 'Non disponible en France';
      });
    });
  }

  function synchronizeVariantUrl(root) {
    matchingOptions(root, 'variant-picker[data-template-product-match="true"][data-mdc-selection-adjusted="true"]').forEach(function (picker) {
      if (picker.closest('product-card, quick-add-dialog')) return;
      var id = picker.dataset.mdcSelectedVariantId;
      if (!id || picker.dataset.mdcSyncedVariantId === id) return;
      picker.dataset.mdcSyncedVariantId = id;
      var url = new URL(window.location.href);
      if (url.searchParams.get('variant') !== id) {
        url.searchParams.set('variant', id);
        window.history.replaceState(window.history.state, '', url.toString());
      }
    });
  }

  function boot(root) {
    synchronizeVariantUrl(root);
    enhanceColors(root);
  }


  // App widgets add many unrelated nodes. Re-scan only when a product option
  // is inserted, and combine updates into one pass per rendered frame.
  var refreshPending = false;
  var pendingRoots = new Set();
  var pendingScans = new Set();
  var optionSelector = "fieldset[data-mdc-color-picker='true'], variant-picker[data-template-product-match='true'][data-mdc-selection-adjusted='true']";
  var optionsObserver = new MutationObserver(function (mutations) {
    if (mutations.some(function (mutation) { return mutation.type === 'childList' && mutation.removedNodes.length; })) {
      forgetDetachedStyles();
    }
    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes') {
        if (mutation.target.matches('[data-mdc-color-only] .variant-option__button-label')) {
          pendingRoots.add(mutation.target.closest('[data-mdc-color-only]'));
        }
        return;
      }
      // Shopify can morph an existing fieldset without inserting a new one.
      // Restore its label after text/removals, while ignoring our own writes.
      var target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
      if (target && target.closest("fieldset[data-mdc-color-picker='true']") && !target.closest('.mdc-color-current')) {
        var ownMarkerOnly = mutation.removedNodes.length === 0 && mutation.addedNodes.length > 0 &&
          Array.prototype.every.call(mutation.addedNodes, function (node) {
            return node.nodeType === 1 && node.matches('.mdc-color-current');
          });
        if (!ownMarkerOnly) pendingRoots.add(target.closest("fieldset[data-mdc-color-picker='true']"));
      }
      Array.prototype.forEach.call(mutation.addedNodes, function (node) {
        if (node.nodeType !== 1 || node.matches('.mdc-color-current')) return;
        pendingScans.add(node);
      });
    });
    if ((!pendingRoots.size && !pendingScans.size) || refreshPending) return;
    refreshPending = true;
    window.requestAnimationFrame(function () {
      refreshPending = false;
      var scans = Array.from(pendingScans).filter(function (node) { return node.isConnected; });
      pendingScans.clear();
      var scanSet = new Set(scans);
      scans.filter(function (node) {
        var parent = node.parentElement;
        while (parent) {
          if (scanSet.has(parent)) return false;
          parent = parent.parentElement;
        }
        return true;
      }).forEach(function (node) {
        if (node.matches(optionSelector)) pendingRoots.add(node);
        if (node.firstElementChild) {
          node.querySelectorAll(optionSelector).forEach(function (option) { pendingRoots.add(option); });
        }
      });
      var roots = Array.from(pendingRoots).filter(function (root) { return root.isConnected; });
      pendingRoots.clear();
      roots.filter(function (root) {
        return !roots.some(function (other) { return other !== root && other.contains(root); });
      }).forEach(boot);
    });
  });
  optionsObserver.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

})();

